export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--J.2fad7121.png";